import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {MENUITEM} from '../constants';
import {Get, Post, Put, DeleteSingle} from '../../utils/httpProvider';
import {MENU_API} from '../../utils/apiUrl.js';

export const getMenuAction = createAsyncThunk(
    MENUITEM.GET_MENU,
    async () => {
        return Get(MENU_API.GET_MENU, null, null)
            .then((response) => {
                return response;
            })
            .catch((error) => error);
    }
);

const initialState = {
    listMenu: [],
    totalListMenu: 0,
    status: 'idle',
    // apiRoleMappingItem: null
};
export const menuItemSlice = createSlice({
    name: MENUITEM.NAME_SLICE,
    initialState,
    reducers: {
        filterListMenu: (state, action) => {
            state.listMenu =
                state.listMenu.length > 0
                    ? state.listMenu.filter(
                          (x) => x.id !== action.payload
                      )
                    : [];
            // state.totalApiRoleMapping -= 1;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getMenuAction.pending, (state)=>{ state.status='loading'; })
            .addCase(getMenuAction.fulfilled, (state, action) => {
                state.listMenu =
                    action.payload &&
                    action.payload.data
                        ? action.payload.data
                        : [];
                // state.totalApiRoleMapping =
                //     action.payload && action.payload.totalRecords
                //         ? action.payload.totalRecords
                //         : 0;
            })
            .addCase(getMenuAction.rejected, (state)=>{ state.status='failed'; });
    }
});

export const {filterListApiRoleMapping} = menuItemSlice.actions;

export default menuItemSlice.reducer;
